import { textColorClassName, textFontClassName } from "./commonClassNames";
import { ChildrenOnlyProp } from "./commonProps";

const commonHeadingClassName = "mt-0 mb-2";

export const Heading1: React.FC<ChildrenOnlyProp> = ({ children }) => {
  const className = [
    commonHeadingClassName,
    textFontClassName({ font: "bold", size: "5xl" }),
    textColorClassName({}),
  ].join(" ");

  return <h1 className={className}>{children}</h1>;
};

export const Heading2: React.FC<ChildrenOnlyProp> = ({ children }) => {
  const className = [
    commonHeadingClassName,
    textFontClassName({ font: "bold", size: "4xl" }),
    textColorClassName({}),
  ].join(" ");

  return <h2 className={className}>{children}</h2>;
};

export const Heading3: React.FC<ChildrenOnlyProp> = ({ children }) => {
  const className = [
    commonHeadingClassName,
    textFontClassName({ font: "bold", size: "3xl" }),
    textColorClassName({}),
  ].join(" ");

  return <h3 className={className}>{children}</h3>;
};

export const Heading4: React.FC<ChildrenOnlyProp> = ({ children }) => {
  const className = [
    commonHeadingClassName,
    textFontClassName({ font: "bold", size: "2xl" }),
    textColorClassName({}),
  ].join(" ");

  return <h3 className={className}>{children}</h3>;
};

export const Heading5: React.FC<ChildrenOnlyProp> = ({ children }) => {
  const className = [
    commonHeadingClassName,
    textFontClassName({ font: "semibold", size: "xl" }),
    textColorClassName({}),
  ].join(" ");

  return <h4 className={className}>{children}</h4>;
};
